var Backbone, SupportFinePrintPresenterPresentation, SupportFinePrintTemplate, SupportFinePrintView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportFinePrintPresenterPresentation = require('../../presenters/fine_print_presenter');

Backbone = require('backbone');

Backbone.$ = $;

SupportFinePrintTemplate = require('../../../fine_print.html.mustache');

SupportFinePrintView = (function(superClass) {
  extend(SupportFinePrintView, superClass);

  function SupportFinePrintView() {
    return SupportFinePrintView.__super__.constructor.apply(this, arguments);
  }

  SupportFinePrintView.prototype.id = 'viewPopupContent';

  SupportFinePrintView.prototype.initialize = function() {
    this.I18nScope = 'modules.support';
    return this.template = SupportFinePrintTemplate;
  };

  SupportFinePrintView.prototype.render = function() {
    this.popup = $('#popup');
    GIG.Modal.open({
      el: this.popup,
      closeOnBgClick: true,
      closeOnEscKey: true
    });
    this.$el.html(toHtml(this.template, this.toHash(), this.I18nScope));
    this.popup.html(this.el);
    return openLinksInNewTab($('#popupContent a'));
  };

  SupportFinePrintView.prototype.toHash = function() {
    var ref;
    return {
      fine_print: Groupon.Support.currentOrder.finePrintText || ((ref = Groupon.Support.currentOrder.deal) != null ? ref.finePrintText : void 0)
    };
  };

  SupportFinePrintView.prototype.closeModal = function() {
    GIG.Modal.close();
    return false;
  };

  SupportFinePrintView.prototype.events = {
    'click .close-modal': "closeModal"
  };

  return SupportFinePrintView;

})(Backbone.View);

module.exports = SupportFinePrintView;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9tb2R1bGVzL3N1cHBvcnQvZnJvbnRlbmQvdmlld3Mvb3JkZXJfcmVsYXRlZC9maW5lX3ByaW50X3ZpZXcuY29mZmVlIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9tb2R1bGVzL3N1cHBvcnQvZnJvbnRlbmQvdmlld3Mvb3JkZXJfcmVsYXRlZC9maW5lX3ByaW50X3ZpZXcuY29mZmVlIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLElBQUEsK0ZBQUE7RUFBQTs7O0FBQUEscUNBQUEsR0FBd0MsT0FBQSxDQUFRLHVDQUFSOztBQUN4QyxRQUFBLEdBQVcsT0FBQSxDQUFRLFVBQVI7O0FBQ1gsUUFBUSxDQUFDLENBQVQsR0FBYTs7QUFDYix3QkFBQSxHQUEyQixPQUFBLENBQVEsbUNBQVI7O0FBRXJCOzs7Ozs7O2lDQUNKLEVBQUEsR0FBSTs7aUNBRUosVUFBQSxHQUFZLFNBQUE7SUFDVixJQUFDLENBQUEsU0FBRCxHQUFhO1dBQ2IsSUFBQyxDQUFBLFFBQUQsR0FBWTtFQUZGOztpQ0FJWixNQUFBLEdBQVEsU0FBQTtJQUNOLElBQUMsQ0FBQSxLQUFELEdBQVMsQ0FBQSxDQUFFLFFBQUY7SUFDVCxHQUFHLENBQUMsS0FBSyxDQUFDLElBQVYsQ0FDRTtNQUFBLEVBQUEsRUFBSSxJQUFDLENBQUEsS0FBTDtNQUNBLGNBQUEsRUFBZ0IsSUFEaEI7TUFFQSxhQUFBLEVBQWUsSUFGZjtLQURGO0lBS0EsSUFBQyxDQUFBLEdBQUcsQ0FBQyxJQUFMLENBQVUsTUFBQSxDQUFPLElBQUMsQ0FBQSxRQUFSLEVBQWtCLElBQUMsQ0FBQSxNQUFELENBQUEsQ0FBbEIsRUFBNkIsSUFBQyxDQUFBLFNBQTlCLENBQVY7SUFDQSxJQUFDLENBQUEsS0FBSyxDQUFDLElBQVAsQ0FBWSxJQUFJLENBQUMsRUFBakI7V0FDQSxpQkFBQSxDQUFrQixDQUFBLENBQUUsaUJBQUYsQ0FBbEI7RUFUTTs7aUNBV1IsTUFBQSxHQUFRLFNBQUE7QUFDTixRQUFBO1dBQUE7TUFBQSxVQUFBLEVBQVksT0FBTyxDQUFDLE9BQU8sQ0FBQyxZQUFZLENBQUMsYUFBN0IsNERBQStFLENBQUUsdUJBQTdGOztFQURNOztpQ0FHUixVQUFBLEdBQVksU0FBQTtJQUNWLEdBQUcsQ0FBQyxLQUFLLENBQUMsS0FBVixDQUFBO0FBQ0EsV0FBTztFQUZHOztpQ0FJWixNQUFBLEdBQ0U7SUFBQSxvQkFBQSxFQUF1QixZQUF2Qjs7Ozs7R0ExQitCLFFBQVEsQ0FBQzs7QUE0QjVDLE1BQU0sQ0FBQyxPQUFQLEdBQWlCIn0=
